import type { Consensus } from "../types/api";

interface ConsensusCardsProps {
  consensus: Consensus | null;
}

function warnNoSpaces(item: string) {
  if (item.length > 20 && !/\s/.test(item)) {
    console.warn("Consensus item may lack spaces (backend issue):", item.slice(0, 60));
  }
}

export function ConsensusCards({ consensus }: ConsensusCardsProps) {
  if (!consensus) {
    return <p className="muted-empty">Consensus not available for this run.</p>;
  }

  const cards = [
    { key: "agreement", label: "Agreement", className: "consensus-agree", items: consensus.agreement },
    { key: "debate", label: "Debate", className: "consensus-debate", items: consensus.debate },
    { key: "emerging", label: "Emerging", className: "consensus-emerge", items: consensus.emerging },
  ] as const;

  return (
    <div className="consensus-grid">
      {cards.map(({ key, label, className, items }) => (
        <div key={key} className={`consensus-card ${className}`}>
          <h3>{label}</h3>
          {items.length === 0 ? (
            <p className="muted-empty">None identified</p>
          ) : (
            <ul>
              {items.map((item, i) => {
                warnNoSpaces(item);
                return <li key={i}>{item}</li>;
              })}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}
